<template>
    <div class="rel">
        <div class="form-control d:flex! ai:center" data-bs-toggle="dropdown" v-bind="$attrs">
            <div class="text:ellipsis white-space:nowrap overflow:hidden" v-if="values.length" v-text="title"></div>
            <div class="color:#A9A9A9" v-else v-text="props.placeholder"></div>
            <i class="fa-solid fa-angle-down f:14 ml:auto"></i>
        </div>
        <div @click.stop class="
            dropdown-menu w:full max-h:242 overflow:auto
            {d:block;p:18|15;lh:1}>label
            {bg:#EDF5FF}>label:hover
            {m:0|8|0|0}>label>input
            {b:#538BD4;shadow:0|0|0|2|#538BD433}>label>input:hover
        ">
            <label :key="item.id" v-for="(item) in items">
                <input class="form-check-input" :name="`Worktime-${item.id}`" type="checkbox" :value="item.id" v-model="values" />
                {{ item.title }}
            </label>
        </div>
    </div>
</template>

<script setup>
    const props = defineProps({
        modelValue: { type: String },
        placeholder: { default: "請選擇", type: String }
    });

    const items = [
        { id: "1", title: "日班" },
        { id: "64", title: "中班" },
        { id: "2", title: "晚班" },
        { id: "4", title: "大夜班" },
        { id: "8", title: "假日班" },
        { id: "16", title: "輪班" }
    ];

    const title = computed(() => {
        return items.filter((item) => values.value.includes(item.id)).map((item) => item.title).join("、");
    });

    const values = ref(props.modelValue ? props.modelValue.split(",") : []);

    const emit = defineEmits(["update:modelValue"]);

    defineOptions({ inheritAttrs: false });

    watch(values, () => {
        emit("update:modelValue", values.value.join(","));
    });
</script>
